import './App.css';
import InputData from './components/InputData';

function App() {
  return (
    <div className="App">
      <header className="App-header">
       <InputData />
       <h6>Developed by <a href="https://github.com/Deepakmukka1" style={{color:'#3498DB'}} target="_blank" rel="noreferrer">Mukka Deepak</a></h6>
      </header>
    </div>
  );
}

export default App;
